import { TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetInvoiceData,
  GetCapacityDataManagerData,
  GetNonChargeableByReason,
  GetCustomerReport,
  ExportToExcelManagement,
  GetDropDownList,
} from "../../../Helpers/API/APIEndPoints";
import { LoaderContext } from "../../../Helpers/Context/Context";
import notify from "../../../Helpers/ToastNotification";
import { useMemo } from "react";

const ManagementDashboardReport = () => {
  let formErrorObj = {};
  //States
  const [date, setDate] = useState<Date | null>(
    moment().startOf("month").toDate()
  );
  const [isReport, setIsReport] = useState(false);

  const [month, setMonth] = useState(
    moment().startOf("month").toDate().getMonth()
  );
  const [year, setYear] = useState<any>(
    moment().startOf("month").toDate().getFullYear()
  );
  const [reportType, setReportType] = useState({
    value: "0",
    label: "Select Report",
    id: 0,
  });
  const [gridState, setGridState] = useState({
    title: "" as React.ReactNode,
    data: [],
    columns: [],
  });
  const [actual, setActual] = useState([]);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [reset, setReset] = useState(false);
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [costCenterSelectData, setCostCenterSelectData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [currentmonth, setCurrentmonth] = useState(
    moment(moment().startOf("month").toDate()).format("MMMM")
  ); //prashant
  const [previousmonth, setPreviousmonth] = useState(
    moment(moment().subtract(1, "months").startOf("month").toDate()).format(
      "MMMM"
    )
  ); //prashant
  const [data, setGridData] = useState([
    {
      year: 0,
      month: null,
      noChargesReason: null,
      actual: 0,
      plannedTM: 0,
      plannedAMC: 0,
      plannedProject: 0,
      plannedInternal: 0,
      plannedProduct: 0,
      plannedInnovation: 0, //prashant 6th mar,2024
      plannedInfraservices: 0, //prashant 6th mar,2024
      plannedTotal: 0,
      actualTM: 0,
      actualAMC: 0,
      actualProject: 0,
      actualInternal: 0,
      actualProduct: 0,
      actualNonChargeable: 0,
      actualInnovation: 0, //prashant 6th mar,2024
      actualInfraservices: 0, //prashant 6th mar,2024
      actualTotal: 0,
      pendingTM: 0,
      pendingAMC: 0,
      pendingProject: 0,
      pendingProduct: 0,
      pendingInnovation: 0, //prashant 6th mar,2024
      pendingInfraservices: 0, //prashant 6th mar,2024
      pendingTotal: 0,
      actualTMP: 0,
      actualAMCP: 0,
      actualProjectP: 0,
      actualProductP: 0,
      actualInnovationP: 0, //prashant 6th mar,2024
      actualInfraservicesP: 0, //prashant 6th mar,2024
      actualTotalP: 0,
      customerName: "",
      id: 0,
      isActive: false,
      createdDate: "0001-01-01T00:00:00",
      createdBy: 0,
      modifiedDate: null,
      modifiedBy: null,
      //----------prashant new-------------
      currentStream: "",
      previousStream: "",
      previousCarryfwd: 0,
      previousPlanned: 0,
      previousActual: 0,
      previousVariance: 0,
      previousActualP: 0,
      currentCarryfwd: 0,
      currentPlanned: 0,
      currentActual: 0,
      currentVariance: 0,
      currentActualP: 0,
    },
  ]);

  interface MonthData {
    previousCarryfwd?: number;
    previousPlanned?: number;
    previousActual?: number;
    previousVariance?: number;
    previousActualP?: number;
    previousStream?: string;
  }

  interface Month {
    PreviousMonth: MonthData;
    CurrentMonth: MonthData;
  }

  interface InvoiceData {
    AMC: Month;
    "T&M": Month;
    Innovation: Month;
    "License/Infra Services": Month;
    Product: Month;
    Project: Month;
  }

  const [UpgradedInvoiceData, setUpgradedInvoiceData] = useState({
    AMC: {
      PreviousMonth: {},
      CurrentMonth: {},
    },
    "T&M": {
      PreviousMonth: {},
      CurrentMonth: {},
    },
    Innovation: {
      PreviousMonth: {},
      CurrentMonth: {},
    },
    "License/Infra Services": {
      PreviousMonth: {},
      CurrentMonth: {},
    },
    Product: {
      PreviousMonth: {},
      CurrentMonth: {},
    },
    Project: {
      PreviousMonth: {},
      CurrentMonth: {},
    },
  } as InvoiceData);

  const [capacityData, setCapacityData] = useState([
    {
      year: 0,
      month: 0,
      plannedTM: 0,
      plannedAMC: 0,
      workingDay: 0,
      plannedProject: 0,
      plannedProduct: 0,
      plannedInefficients: 0, //prashant
      plannedInternal: 0,
      plannedNonChargeable: 0,
      plannedleaves: 0,
      plannedSpare: 0,
      plannedTotal: 0,
      actualTM: 0,
      actualAMC: 0,
      actualProject: 0,
      actualProdcut: 0,
      actualInefficients: 0, //prashant
      actualInternal: 0,
      actualNonChargeable: 0,
      actualLeaves: 0,
      actualSpare: 0,
      actualTotal: 0,
      varianceTM: 0,
      varianceAMC: 0,
      varianceProject: 0,
      varianceProduct: 0,
      varianceInternal: 0,
      varianceNonChargeable: 0,
      varianceInefficient: 0, //prashant
      varianceLeaves: 0,
      varianceSpare: 0,
      varianceTotal: 0,
      plannedCapacityTM: 0,
      plannedCapacityAMC: 0,
      plannedCapacityProject: 0,
      plannedCapcityProduct: 0,
      plannedCapacityInternal: 0,
      plannedCapacityNonChargeable: 0,
      plannedCapacityLeaves: 0,
      plannedCapacitySpare: 0,
      actualCapacityTM: 0,
      actualCapacityAMC: 0,
      actualCapacityProject: 0,
      actualCapacityProduct: 0,
      actualCapacityNonChargeable: 0,
      actualCapacityInternal: 0,
      actualCapacityLeaves: 0,
      actualCapacitySpare: 0,
      resourceTM: 0,
      resourceAMC: 0,
      resourceProject: 0,
      resourceProduct: 0,
      resourceNonchargeable: 0,
      resourceleaves: 0,
      resourceInternal: 0,
      resourceSpare: 0,
      resourceTotal: 0,
      actualResourceTM: 0,
      actualResourceAMC: 0,
      actualResourceProject: 0,
      actualResourceProduct: 0,
      actualResourceInternal: 0,
      actualResourceNonChargeable: 0,
      actualResourceLeaves: 0,
      actualResourceSpare: 0,
      actualResourceTotal: 0,
      id: 0,
      isActive: 0,
      createdDate: 0,
      createdBy: 0,
      modifiedDate: 0,
      modifiedBy: 0,
      plannedCapacityTotal: 0,
      actualCapacityTotal: 0,
      customerName: 0,
      //--------prashant--------
      plannedInnovation: 0,
      plannedInfraservices: 0,
      actualInnovation: 0,
      actualInfraservices: 0,
      varianceInnovation: 0,
      varianceInfraservices: 0,
      plannedCapacityInnovation: 0,
      plannedCapacityInfraservices: 0,
      actualCapacityInnovation: 0,
      actualCapacityInfraservices: 0,
      resourceInnovation: 0,
      resourceInfraservices: 0,
      actualResourceInnovation: 0,
      actualResourceInfraservices: 0,
      actualCapacityInefficients: 0,
      plannedCapacityInefficients: 0,
    },
  ]);

  //Hardcoded Values
  const reportOptions = [
    { value: "invoice", label: "Invoice This Month", id: 1 },
    { value: "capacity", label: "Capacity Utilization", id: 2 },
    { value: "non-charge", label: "Non Chargeable Mandays by Reason", id: 3 },
    { value: "customer", label: "Customer", id: 4 },
  ];

  const gridColums_Invoice = [
    //--------------------Prashant new -----------------

    {
      name: "name",
      label: "Streams",
    },
    // {
    //   name : "Month",
    //   label : "Month",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {

    //       let previousMonthIndex = (month - 1) % 12; // Calculate the index of the previous month
    //       let previousYear = year; // Initialize previousYear with current year
    //       if (previousMonthIndex < 0) {
    //         // If the previous month is December, adjust both month and year
    //         previousMonthIndex = 11; // Set to December
    //         previousYear--; // Decrement the year
    //       }
    //           let my = {
    //             Month: months[previousMonthIndex], // Access the previous month name from the array
    //             Year: previousYear,
    //           };
    //       return (
    //         <td style={{ transform: 'rotate(-45deg)', whiteSpace: 'nowrap' }}>
    //           {my.Month}
    //         </td>
    //       );
    //     },
    //   },
    // },

    //Previous month
    {
      name: "previousCarryfwd",
      label: "Carry fwd",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "previousPlanned",
      label: "Planned",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),

        // customHeadLabelRender: () => {
        //   return <span>March</span>
        // }
      },
    },
    {
      name: "previousActual",
      label: "Actual",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "previousVariance",
      label: "Variance",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "previousActualP",
      label: "Actual %",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },

    //current month
    // {
    //   name : "Month",
    //   label : "Month",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       let my = {
    //         Month: months[month],
    //         Year: year,
    //       };
    //       return (
    //         <td style={{ transform: 'rotate(-45deg)', whiteSpace: 'nowrap' }}>
    //           {my.Month}
    //         </td>
    //       );
    //     },
    //   },
    // },

    {
      name: "currentCarryfwd",
      label: "Carry fwd",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "currentPlanned",
      label: "Planned",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "currentActual",
      label: "Actual",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "currentVariance",
      label: "Variance",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    {
      name: "currentActualP",
      label: "Actual %",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
        },
        setCellProps: () => ({ align: "right" }),
        setCellHeaderProps: () => ({ style: { textAlign: "right" } }),
      },
    },
    // {
    //   name: "name",
    //   label: "      ",
    // },
    // {
    //   name: "tm",
    //   label: "T&M",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "amc",
    //   label: "AMC",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "project",
    //   label: "Project",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "product",
    //   label: "Product",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "innovation",  //prashant 6th mar,2024
    //   label: "Innovation",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "infraservices",  //prashant 6th mar,2024
    //   label: "License/Infra services",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
    // {
    //   name: "tot",
    //   label: "Total",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{Intl.NumberFormat("en-IN").format(value)}</span>;
    //     },
    //   },
    // },
  ];

  const gridColums_Capacity = [
    {
      name: "name",
      label: "       ",
    },
    {
      name: "workingDay",
      label: "Working Day",
    },
    {
      name: "tm",
      label: "T&M",
    },
    {
      name: "amc",
      label: "AMC",
    },
    {
      name: "project",
      label: "Project",
    },
    {
      name: "product",
      label: "Product",
    },
    {
      name: "innovationc", //prashant
      label: "Innovation",
    },
    {
      name: "infraservicesc", //prashant
      label: "Licens/Infra Services",
    },
    {
      name: "internalb",
      label: "Internal",
    },

    {
      name: "nonCharge",
      label: "Non Chargeable",
    },
    {
      name: "inefficient", //Prashant
      label: "Inefficient",
    },
    {
      name: "leaves",
      label: "Leaves",
    },
    {
      name: "spare",
      label: "Spare",
    },
    {
      name: "tot",
      label: "Total",
    },
  ];

  const gridColums_Non_Charageable = [
    {
      name: "noChargesReason",
      label: "    ",
    },
    {
      name: "actual",
      label: "Actual",
    },
  ];
  const gridColums_Customer = [
    {
      name: "customerName",
      label: "Customer Name",
    },
    {
      name: "plannedTM",
      label: "Planned TM",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "plannedAMC",
      label: "Planned AMC",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },

    {
      name: "plannedProject",
      label: "Planned Project",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "plannedProduct",
      label: "Planned Product",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "plannedInternal",
      label: "Planned Internal",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "plannedInefficient", //Prashant
      label: "Planned Inefficient",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "plannedTotal",
      label: "Planned Total",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualTM",
      label: "Actual TM",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualAMC",
      label: "Actual AMC",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },

    {
      name: "actualProject",
      label: "Actual Project",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualProdcut",
      label: "Actual Product",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },

    {
      name: "actualInternal",
      label: "Actual Internal",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualNonChargeable",
      label: "Actual NonChargeable",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualInefficient", //prashant
      label: "Actual Inefficient",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
    {
      name: "actualTotal",
      label: "Actual Total",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span>{Math.round(value)}</span>;
        },
      },
    },
  ];

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dataset = [
    //-----------------Prashant new----------------

    {
      name: "AMC",
      previousCarryfwd: UpgradedInvoiceData["AMC"]["PreviousMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["AMC"]["PreviousMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
        ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["AMC"]["PreviousMonth"]
        .previousVariance
        ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["AMC"]["PreviousMonth"]
        .previousActualP
        ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["AMC"]["CurrentMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
        ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
        ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["AMC"]["CurrentMonth"]
        .previousVariance
        ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActualP
        ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActualP
        : 0,
    },
    {
      name: "Innovation",
      previousCarryfwd: UpgradedInvoiceData["Innovation"]["PreviousMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["Innovation"]["PreviousMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["Innovation"]["PreviousMonth"]
        .previousActual
        ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["Innovation"]["PreviousMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["Innovation"]["PreviousMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["Innovation"]["CurrentMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["Innovation"]["CurrentMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["Innovation"]["CurrentMonth"]
        .previousActual
        ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["Innovation"]["CurrentMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["Innovation"]["CurrentMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActualP
        : 0,
    },
    {
      name: "License/Infra Services",
      previousCarryfwd: UpgradedInvoiceData["License/Infra Services"][
        "PreviousMonth"
      ].previousCarryfwd
        ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["License/Infra Services"][
        "PreviousMonth"
      ].previousPlanned
        ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["License/Infra Services"][
        "PreviousMonth"
      ].previousActual
        ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["License/Infra Services"][
        "PreviousMonth"
      ].previousVariance
        ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["License/Infra Services"][
        "PreviousMonth"
      ].previousActualP
        ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["License/Infra Services"][
        "CurrentMonth"
      ].previousCarryfwd
        ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
            .previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["License/Infra Services"][
        "CurrentMonth"
      ].previousPlanned
        ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
            .previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["License/Infra Services"][
        "CurrentMonth"
      ].previousActual
        ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
            .previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["License/Infra Services"][
        "CurrentMonth"
      ].previousVariance
        ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
            .previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["License/Infra Services"][
        "CurrentMonth"
      ].previousActualP
        ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
            .previousActualP
        : 0,
    },
    {
      name: "Product",
      previousCarryfwd: UpgradedInvoiceData["Product"]["PreviousMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["Product"]["PreviousMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["Product"]["PreviousMonth"]
        .previousActual
        ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["Product"]["PreviousMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["Product"]["PreviousMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["Product"]["CurrentMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["Product"]["CurrentMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["Product"]["CurrentMonth"]
        .previousActual
        ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["Product"]["CurrentMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["Product"]["CurrentMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousActualP
        : 0,
    },
    {
      name: "Project",
      previousCarryfwd: UpgradedInvoiceData["Project"]["PreviousMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["Project"]["PreviousMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["Project"]["PreviousMonth"]
        .previousActual
        ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["Project"]["PreviousMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["Project"]["PreviousMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["Project"]["CurrentMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["Project"]["CurrentMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["Project"]["CurrentMonth"]
        .previousActual
        ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["Project"]["CurrentMonth"]
        .previousVariance
        ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["Project"]["CurrentMonth"]
        .previousActualP
        ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousActualP
        : 0,
    },
    {
      name: "T&M",
      previousCarryfwd: UpgradedInvoiceData["T&M"]["PreviousMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousCarryfwd
        : 0,
      previousPlanned: UpgradedInvoiceData["T&M"]["PreviousMonth"]
        .previousPlanned
        ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
        : 0,
      previousActual: UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
        ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
        : 0,
      previousVariance: UpgradedInvoiceData["T&M"]["PreviousMonth"]
        .previousVariance
        ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousVariance
        : 0,
      previousActualP: UpgradedInvoiceData["T&M"]["PreviousMonth"]
        .previousActualP
        ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActualP
        : 0,

      currentCarryfwd: UpgradedInvoiceData["T&M"]["CurrentMonth"]
        .previousCarryfwd
        ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousCarryfwd
        : 0,
      currentPlanned: UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
        ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
        : 0,
      currentActual: UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
        ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
        : 0,
      currentVariance: UpgradedInvoiceData["T&M"]["CurrentMonth"]
        .previousVariance
        ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousVariance
        : 0,
      currentActualP: UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActualP
        ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActualP
        : 0,
    },
    {
      name: "Total",
      previousCarryfwd:
        (UpgradedInvoiceData["AMC"]["PreviousMonth"].previousCarryfwd
          ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
          .previousCarryfwd
          ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
              .previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Product"]["PreviousMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Project"]["PreviousMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousCarryfwd
          ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousCarryfwd
          : 0),

      previousPlanned:
        (UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
          ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousPlanned
          ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
          .previousPlanned
          ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
              .previousPlanned
          : 0) +
        (UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
          ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
          ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
          ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
          : 0),

      previousActual:
        (UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
          .previousActual
          ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
              .previousActual
          : 0) +
        (UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
          : 0),

      previousVariance:
        (UpgradedInvoiceData["AMC"]["PreviousMonth"].previousVariance
          ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousVariance
          ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
          .previousVariance
          ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
              .previousVariance
          : 0) +
        (UpgradedInvoiceData["Product"]["PreviousMonth"].previousVariance
          ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["Project"]["PreviousMonth"].previousVariance
          ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousVariance
          ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousVariance
          : 0),

      /*ROUND(isnull((SUM(ActualTM)+sum(ActualAMC)+sum(ActualPROJECT)+sum(ActualInnovation)+sum(ActualInfraservices)+sum(ActualPRODUCT))/
      (SUM(PlannedTM)+sum(PlannedAMC)+sum(PlannedPROJECT)+sum(PlannedInnovation)+sum(PlannedInfraservices)+sum(PlannedProduct))*100,0),1)*/
      previousActualP: isNaN(
        (((UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
          ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
          : 0) +
          (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
            ? UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
            : 0) +
          (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
            .previousActual
            ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
                .previousActual
            : 0) +
          (UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
            ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
            : 0) +
          (UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
            ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
            : 0) +
          (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
            ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
            : 0)) /
          ((UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
            ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
            : 0) +
            (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousPlanned
              ? UpgradedInvoiceData["Innovation"]["PreviousMonth"]
                  .previousPlanned
              : 0) +
            (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
              .previousPlanned
              ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
                  .previousPlanned
              : 0) +
            (UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
              ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
              : 0) +
            (UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
              ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
              : 0) +
            (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
              ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
              : 0))) *
          100
      )
        ? 0
        : Math.floor(
            (((UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
              ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousActual
              : 0) +
              (UpgradedInvoiceData["Innovation"]["PreviousMonth"].previousActual
                ? UpgradedInvoiceData["Innovation"]["PreviousMonth"]
                    .previousActual
                : 0) +
              (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
                .previousActual
                ? UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
                    .previousActual
                : 0) +
              (UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
                ? UpgradedInvoiceData["Product"]["PreviousMonth"].previousActual
                : 0) +
              (UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
                ? UpgradedInvoiceData["Project"]["PreviousMonth"].previousActual
                : 0) +
              (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
                ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousActual
                : 0)) /
              ((UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
                ? UpgradedInvoiceData["AMC"]["PreviousMonth"].previousPlanned
                : 0) +
                (UpgradedInvoiceData["Innovation"]["PreviousMonth"]
                  .previousPlanned
                  ? UpgradedInvoiceData["Innovation"]["PreviousMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["License/Infra Services"]["PreviousMonth"]
                  .previousPlanned
                  ? UpgradedInvoiceData["License/Infra Services"][
                      "PreviousMonth"
                    ].previousPlanned
                  : 0) +
                (UpgradedInvoiceData["Product"]["PreviousMonth"].previousPlanned
                  ? UpgradedInvoiceData["Product"]["PreviousMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["Project"]["PreviousMonth"].previousPlanned
                  ? UpgradedInvoiceData["Project"]["PreviousMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
                  ? UpgradedInvoiceData["T&M"]["PreviousMonth"].previousPlanned
                  : 0))) *
              100
          ),

      /*(data[0] && data[0].previousActualP ?data[0].previousActualP  :0 )+ 
      // (data[1] && data[1].previousActualP ?data[1].previousActualP  :0 )+
      // (data[2] && data[2].previousActualP ?data[2].previousActualP  :0 )+
      // (data[3] && data[3].previousActualP ?data[3].previousActualP  :0 )+
      // (data[4] && data[4].previousActualP ?data[4].previousActualP  :0 )+
      // (data[5] && data[5].previousActualP ?data[5].previousActualP  :0 ),*/

      currentCarryfwd:
        (UpgradedInvoiceData["AMC"]["CurrentMonth"].previousCarryfwd
          ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
          .previousCarryfwd
          ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
              .previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Product"]["CurrentMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["Project"]["CurrentMonth"].previousCarryfwd
          ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousCarryfwd
          : 0) +
        (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousCarryfwd
          ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousCarryfwd
          : 0),

      currentPlanned:
        (UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
          ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousPlanned
          ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
          .previousPlanned
          ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
              .previousPlanned
          : 0) +
        (UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
          ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
          ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
          : 0) +
        (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
          ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
          : 0),

      currentActual:
        (UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
          ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
          ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
          .previousActual
          ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
              .previousActual
          : 0) +
        (UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
          ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
          ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
          : 0) +
        (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
          ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
          : 0),

      currentVariance:
        (UpgradedInvoiceData["AMC"]["CurrentMonth"].previousVariance
          ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousVariance
          ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
          .previousVariance
          ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
              .previousVariance
          : 0) +
        (UpgradedInvoiceData["Product"]["CurrentMonth"].previousVariance
          ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["Project"]["CurrentMonth"].previousVariance
          ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousVariance
          : 0) +
        (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousVariance
          ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousVariance
          : 0),

      currentActualP: Math.floor(
        isNaN(
          (((UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
            ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
            : 0) +
            (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
              ? UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
              : 0) +
            (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
              .previousActual
              ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                  .previousActual
              : 0) +
            (UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
              ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
              : 0) +
            (UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
              ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
              : 0) +
            (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
              ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
              : 0)) /
            ((UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
              ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
              : 0) +
              (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousPlanned
                ? UpgradedInvoiceData["Innovation"]["CurrentMonth"]
                    .previousPlanned
                : 0) +
              (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                .previousPlanned
                ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                    .previousPlanned
                : 0) +
              (UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
                ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
                : 0) +
              (UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
                ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
                : 0) +
              (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
                ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
                : 0))) *
            100
        )
          ? 0
          : (((UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
              ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousActual
              : 0) +
              (UpgradedInvoiceData["Innovation"]["CurrentMonth"].previousActual
                ? UpgradedInvoiceData["Innovation"]["CurrentMonth"]
                    .previousActual
                : 0) +
              (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                .previousActual
                ? UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                    .previousActual
                : 0) +
              (UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
                ? UpgradedInvoiceData["Product"]["CurrentMonth"].previousActual
                : 0) +
              (UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
                ? UpgradedInvoiceData["Project"]["CurrentMonth"].previousActual
                : 0) +
              (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
                ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousActual
                : 0)) /
              ((UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
                ? UpgradedInvoiceData["AMC"]["CurrentMonth"].previousPlanned
                : 0) +
                (UpgradedInvoiceData["Innovation"]["CurrentMonth"]
                  .previousPlanned
                  ? UpgradedInvoiceData["Innovation"]["CurrentMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["License/Infra Services"]["CurrentMonth"]
                  .previousPlanned
                  ? UpgradedInvoiceData["License/Infra Services"][
                      "CurrentMonth"
                    ].previousPlanned
                  : 0) +
                (UpgradedInvoiceData["Product"]["CurrentMonth"].previousPlanned
                  ? UpgradedInvoiceData["Product"]["CurrentMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["Project"]["CurrentMonth"].previousPlanned
                  ? UpgradedInvoiceData["Project"]["CurrentMonth"]
                      .previousPlanned
                  : 0) +
                (UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
                  ? UpgradedInvoiceData["T&M"]["CurrentMonth"].previousPlanned
                  : 0))) *
              100
      ),
    },

    //------------------------------------------------

    // {
    //   name: "Planned Invoices",
    //   tm: data[0].plannedTM,
    //   amc: data[0].plannedAMC,
    //   project: data[0].plannedProject,
    //   product: data[0].plannedProduct,
    //   innovation :data[0].plannedInnovation, //prashant 6th mar,2024
    //   infraservices : data[0].plannedInfraservices,//prashant 6th mar,2024
    //   tot: data[0].plannedTotal,
    // },
    // {
    //   name: "Actual Invoices",
    //   tm: data[0].actualTM,
    //   amc: data[0].actualAMC,
    //   project: data[0].actualProject,
    //   product: data[0].actualProduct,
    //   innovation :data[0].actualInnovation, //prashant 6th mar,2024
    //   infraservices : data[0].actualInfraservices, //prashant 6th mar,2024
    //   tot: data[0].actualTotal,
    // },
    // {
    //   name: "Pending",
    //   tm: data[0].pendingTM,
    //   amc: data[0].pendingAMC,
    //   project: data[0].pendingProject,
    //   product: data[0].pendingProduct,
    //   innovation :data[0].pendingInnovation, //prashant 6th mar,2024
    //   infraservices : data[0].pendingInfraservices, //prashant 6th mar,2024
    //   tot: data[0].pendingTotal,
    // },
    // {
    //   name: "Actual %",
    //   tm: data[0].actualTMP,
    //   amc: data[0].actualAMCP,
    //   project: data[0].actualProjectP,
    //   product: data[0].actualProductP,
    //   innovation :data[0].actualInnovationP, //prashant 6th mar,2024
    //   infraservices : data[0].actualInfraservicesP, //prashant 6th mar,2024
    //   tot: data[0].actualTotalP,
    // },
  ];

  const dataset_2 = [
    {
      name: "Planned Capacity - Mandays",
      workingDay: capacityData[0].workingDay,
      tm: Math.round(capacityData[0].plannedTM),
      amc: Math.round(capacityData[0].plannedAMC),
      project: Math.round(capacityData[0].plannedProject),
      product: Math.round(capacityData[0].plannedProduct),
      innovationc: Math.round(capacityData[0].plannedInnovation),
      infraservicesc: Math.round(capacityData[0].plannedInfraservices),
      internalb: Math.round(capacityData[0].plannedInternal),
      nonCharge: Math.round(capacityData[0].plannedNonChargeable),
      leaves: Math.round(capacityData[0].plannedleaves),
      spare: Math.round(capacityData[0].plannedSpare),
      tot: Math.round(capacityData[0].plannedTotal),
      inefficient: Math.round(capacityData[0].plannedInefficients), //prashant
    },
    {
      name: "Actual Capacity - Mandays",
      workingDay: capacityData[0].workingDay,
      tm: Math.round(capacityData[0].actualTM),
      amc: Math.round(capacityData[0].actualAMC),
      project: Math.round(capacityData[0].actualProject),
      product: Math.round(capacityData[0].actualProdcut),
      innovationc: Math.round(capacityData[0].actualInnovation),
      infraservicesc: Math.round(capacityData[0].actualInfraservices),
      internalb: Math.round(capacityData[0].actualInternal),
      nonCharge: Math.round(capacityData[0].actualNonChargeable),
      leaves: Math.round(capacityData[0].actualLeaves),
      spare: Math.round(capacityData[0].actualSpare),
      tot: Math.round(capacityData[0].actualTotal),
      inefficient: Math.round(capacityData[0].actualInefficients), //prashant
    },
    {
      name: "Variance",
      workingDay: "",
      tm: Math.round(capacityData[0].varianceTM),
      amc: Math.round(capacityData[0].varianceAMC),
      project: Math.round(capacityData[0].varianceProject),
      product: Math.round(capacityData[0].varianceProduct),
      innovationc: Math.round(capacityData[0].varianceInnovation),
      infraservicesc: Math.round(capacityData[0].varianceInfraservices),
      internalb: Math.round(capacityData[0].varianceInternal),
      nonCharge: Math.round(capacityData[0].varianceNonChargeable),
      leaves: Math.round(capacityData[0].varianceLeaves),
      spare: Math.round(capacityData[0].varianceSpare),
      tot: Math.round(capacityData[0].varianceTotal),
      inefficient: Math.round(capacityData[0].varianceInefficient), //prashant
    },
    {
      name: "Planned Capacity - %",
      workingDay: "",
      tm: Math.round(capacityData[0].plannedCapacityTM),
      amc: Math.round(capacityData[0].plannedCapacityAMC),
      project: Math.round(capacityData[0].plannedCapacityProject),
      product: Math.round(capacityData[0].plannedCapcityProduct),
      innovationc: Math.round(capacityData[0].plannedCapacityInnovation),
      infraservicesc: Math.round(capacityData[0].plannedCapacityInfraservices),
      internalb: Math.round(capacityData[0].plannedCapacityInternal),
      nonCharge: Math.round(capacityData[0].plannedCapacityNonChargeable),
      leaves: Math.round(capacityData[0].plannedCapacityLeaves),
      spare: Math.round(capacityData[0].plannedCapacitySpare),
      tot: Math.round(capacityData[0].plannedCapacityTotal),
      inefficient: Math.round(capacityData[0].plannedCapacityInefficients), //prashant
    },
    {
      name: "Actual Capacity - %",
      workingDay: "",
      tm: Math.round(capacityData[0].actualCapacityTM),
      amc: Math.round(capacityData[0].actualCapacityAMC),
      project: Math.round(capacityData[0].actualCapacityProject),
      product: Math.round(capacityData[0].actualCapacityProduct),
      innovationc: Math.round(capacityData[0].actualCapacityInnovation),
      infraservicesc: Math.round(capacityData[0].actualCapacityInfraservices),
      internalb: Math.round(capacityData[0].actualCapacityInternal),
      nonCharge: Math.round(capacityData[0].actualCapacityNonChargeable), //capacityData[0].ac,
      leaves: Math.round(capacityData[0].actualCapacityLeaves),
      spare: Math.round(capacityData[0].actualCapacitySpare),
      tot: Math.round(capacityData[0].actualCapacityTotal),
      inefficient: Math.round(capacityData[0].actualCapacityInefficients), //prashant
    },
    {
      name: "Planned Capacity - Resource",
      workingDay: "",
      tm: Math.round(capacityData[0].resourceTM),
      amc: Math.round(capacityData[0].resourceAMC),
      project: Math.round(capacityData[0].resourceProject),
      product: Math.round(capacityData[0].resourceProduct),
      innovationc: Math.round(capacityData[0].resourceInnovation),
      infraservicesc: Math.round(capacityData[0].resourceInfraservices),
      internalb: Math.round(capacityData[0].resourceInternal),
      nonCharge: Math.round(capacityData[0].resourceNonchargeable),
      leaves: Math.round(capacityData[0].resourceleaves),
      spare: Math.round(capacityData[0].resourceSpare),
      tot: Math.round(capacityData[0].resourceTotal),
    },
    {
      name: "Actual Capacity - Resource",
      workingDay: "",
      tm: Math.round(capacityData[0].actualResourceTM),
      amc: Math.round(capacityData[0].actualResourceAMC),
      project: Math.round(capacityData[0].actualResourceProject),
      product: Math.round(capacityData[0].actualResourceProduct),
      innovationc: Math.round(capacityData[0].actualResourceInnovation),
      infraservicesc: Math.round(capacityData[0].actualResourceInfraservices),
      internalb: Math.round(capacityData[0].actualResourceInternal),
      nonCharge: Math.round(capacityData[0].actualResourceNonChargeable),
      leaves: Math.round(capacityData[0].actualResourceLeaves),
      spare: Math.round(capacityData[0].actualResourceSpare),
      tot: Math.round(capacityData[0].actualResourceTotal),
    },
  ];

  //UseEffects
  useEffect(() => {
    onLoadApi();
  }, []);

  useEffect(() => {
    if (!isReport) {
      setGridState({
        title: (
          <>
            <h3>Invoice This Month</h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "30%",
              }}
            >
              <div
                style={{ width: "40vw", marginLeft: "8%", fontWeight: "bold" }}
              >
                {previousmonth}
              </div>
              <div
                style={{ width: "30vw", marginLeft: "40%", fontWeight: "bold" }}
              >
                {currentmonth}{" "}
              </div>
            </div>
          </>
        ),
        data: dataset,
        columns: gridColums_Invoice,
      });
    }
  }, [data]);
  useEffect(() => {
    if (!isReport) {
      setGridState({
        title: "Capacity Utilization",
        data: dataset_2,
        columns: gridColums_Capacity,
      });
    }
  }, [capacityData]);

  useEffect(() => {
    if (!isReport) {
      setGridState({
        title: "Non-chargeable Mandays - by reason",
        data: actual,
        columns: gridColums_Non_Charageable,
      });
    }
  }, [actual]);
  useEffect(() => {
    if (!isReport) {
      setGridState({
        title: "Customer Report",
        data: customerData,
        columns: gridColums_Customer,
      });
    }
  }, [customerData]);

  useEffect(() => {
    if (!isReport) {
      setGridState({
        title: "",
        data: [],
        columns: [],
      });
    }
  }, []);

  //Helpers Functions
  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.id));
    return s.join(",");
  };

  const GetCostCenterOptions = async () => {
    let postObject = {
      searchFor: "costCenter",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data !== null) {
      let options = [];
      data.map((item, index) => {
        options.push({ value: item.label, label: item.label, id: item.value });
      });
      options.sort((a, b) => a.label.localeCompare(b.label));
      setCostCenterOptions(options);
    }
  };

  const SelectOnChange = (e, apiField) => {
    if (apiField === "Year&Month") {
      setDate(e);
      const mm = moment(e).toDate().getMonth();
      const yyyy = moment(e).toDate().getFullYear();
      setMonth(mm);
      setYear(yyyy);

      const currentmon = moment(moment(e).toDate()).format("MMMM");
      let previousmon;

      if (currentmon === "January") {
        previousmon = "December";
      } else {
        previousmon = moment(moment(e).toDate())
          .subtract(1, "months")
          .format("MMMM");
      }

      setCurrentmonth(currentmon);
      setPreviousmonth(previousmon);
    }
    if (apiField === "report") {
      setReportType(e);
      if (e) {
        setFormErrors((preState) => ({
          ...preState,
          ["report_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["report_isEmpty"]: "Please Select Report",
        }));
      }
    }
    if (apiField === "costCenter") {
      setCostCenterSelectData(e);
    }
  };
  useEffect(() => {
    if (reportType.id === 4) {
      GetCustomerReports();
    }
  }, [start, pageSize]);

  const submitFunc = async (apiField) => {
    var objError = {};

    await setFormErrors({});

    if (apiField === "submit") {
      setIsReport(false);
      if (reportType.id === 0) {
        objError["report_isEmpty"] = "Please Select Report";
      } else {
        if (reportType.id === 1) {
          await GetInvoice();
        } else if (reportType.id === 2) {
          await GetCapacity();
        } else if (reportType.id === 3) {
          await GetNonChargeInvoiceData();
        } else if (reportType.id === 4) {
          GetCustomerReports();
        }
      }
    }

    formErrorObj = objError;

    await setFormErrors(objError);

    if (apiField === "reset") {
      setMonth(moment().startOf("month").toDate().getMonth());
      setYear(moment().startOf("month").toDate().getFullYear());
      setCostCenterSelectData([]);
      setDate(moment().startOf("month").toDate());
      setReportType({ value: "0", label: "Select Report", id: 0 });
      setGridState({
        title: "",
        data: [],
        columns: [],
      });

      setUpgradedInvoiceData({
        AMC: {
          PreviousMonth: {},
          CurrentMonth: {},
        },
        "T&M": {
          PreviousMonth: {},
          CurrentMonth: {},
        },
        Innovation: {
          PreviousMonth: {},
          CurrentMonth: {},
        },
        "License/Infra Services": {
          PreviousMonth: {},
          CurrentMonth: {},
        },
        Product: {
          PreviousMonth: {},
          CurrentMonth: {},
        },
        Project: {
          PreviousMonth: {},
          CurrentMonth: {},
        },
      } as InvoiceData);
      setReset(!reset);
    }
  };

  const onLoadApi = async () => {
    showLoader();
    await GetCostCenterOptions();
    hideLoader();
  };

  //Api Calls
  const GetCustomerReports = async () => {
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    let obj = {
      Month: months[month],
      Year: year,
      CostCenterId: costcenterId,
      start: start,
      pageSize: pageSize,
      // isexcel:"No",
    };
    showLoader();
    const { data } = await APICall(GetCustomerReport, "POST", obj);

    if (data !== null) {
      setCustomerData(data);
      //setCount(data.count)
      hideLoader();
    } else {
      setTimeout(() => {
        hideLoader();
      }, 100000);
    }
  };
  const GetNonChargeInvoiceData = async () => {
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    let obj = {
      Month: months[month],
      Year: year,
      CostCenterId: costcenterId,
    };
    showLoader();
    const { data } = await APICall(GetNonChargeableByReason, "POST", obj);
    if (data !== null) {
      setActual(data);
      hideLoader();
    } else {
      setTimeout(() => {
        hideLoader();
      }, 100000);
    }
  };

  //  const setInvoiceDataforCurrentMonth = (stream,tempData) =>{
  //    console.log(stream)
  //    console.log(tempData)
  //    setUpgradedInvoiceData(prevState =>({
  //     ...prevState,
  //     [stream]:{
  //       ...prevState[stream],
  //       CurrentMonth:tempData
  //     }
  //     }))

  //     console.log(UpgradedInvoiceData);
  //  }

  const GetInvoice = async () => {
    let obj = {
      Month: months[month],
      Year: year,
    };
    showLoader();

    setUpgradedInvoiceData({
      AMC: {
        PreviousMonth: {},
        CurrentMonth: {},
      },
      "T&M": {
        PreviousMonth: {},
        CurrentMonth: {},
      },
      Innovation: {
        PreviousMonth: {},
        CurrentMonth: {},
      },
      "License/Infra Services": {
        PreviousMonth: {},
        CurrentMonth: {},
      },
      Product: {
        PreviousMonth: {},
        CurrentMonth: {},
      },
      Project: {
        PreviousMonth: {},
        CurrentMonth: {},
      },
    } as InvoiceData);

    const { data } = await APICall(GetInvoiceData, "POST", obj);

    if (data !== null) {
      setGridData(data);

      // const currentMonthArr = data.filter( currentmonthdata => currentmonthdata.period === "Current Month")

      data.map((d) => {
        setUpgradedInvoiceData((prevState) => ({
          ...prevState,
          [d.previousStream]: {
            ...prevState[d.previousStream],
            [d.period]: d,
          },
        }));
      });

      hideLoader();
    } else {
      setTimeout(() => {
        hideLoader();
      }, 100000);
    }
  };

  const GetCapacity = async () => {
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    let obj = {
      Month: months[month],
      Year: year,
      CostCenterId: costcenterId,
    };
    showLoader();
    const { data } = await APICall(GetCapacityDataManagerData, "POST", obj);

    if (data !== null) {
      setCapacityData(data);
      hideLoader();
    } else {
      setTimeout(() => {
        hideLoader();
      }, 18000);
    }
  };

  const ExportToExcel = async () => {
    var excelObjerror = {};

    await setFormErrors({});
    //debugger;
    setIsReport(true);
    if (reportType.id === 0) {
      excelObjerror["report_isEmpty"] = "Please Select Report";
    } else {
      GetInvoice();

      GetCapacity();

      GetNonChargeInvoiceData();

      GetCustomerReports();

      let obj = {
        Month: months[month],
        Year: year,
        PreviousMonth: previousmonth,
        CurrentMonth: currentmonth,
        Data: dataset,
        Data1: dataset_2,
        Data2: actual,
        Data3: customerData,
        reportTypeId: reportType.id,
      };

      if (actual.length > 0) {
        showLoader();

        await axios
          .request({
            responseType: "blob",
            method: "POST",

            //data: Response,
            url: ExportToExcelManagement,
            //data:JSON,
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              "Access-Control-Allow-Headers": "*",
            },
            data: obj,
          })
          .then((response) => {
            fileDownload(response.data, "ManagementDashboardReport.xlsx");
          })
          .catch((error) => {
            notify(1, "Something went wrong");
          });
      }
      hideLoader();
      setIsReport(true);
    }

    formErrorObj = excelObjerror;
    await setFormErrors(excelObjerror);
  };

  const objects = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,

    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Management Dashboard "} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Select Date <sup>*</sup>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        views={["year", "month"]}
                        label="Year and Month"
                        value={date}
                        onChange={(e) => {
                          SelectOnChange(e, "Year&Month");
                        }}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Report</label>
                    <SelectForm
                      options={reportOptions}
                      placeholder="Select"
                      value={reportType}
                      onChange={(event) => SelectOnChange(event, "report")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>{formErrors["report_isEmpty"]}</p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Vertical</label>
                    <SelectForm
                      value={costCenterSelectData}
                      onChange={(e) => SelectOnChange(e, "costCenter")}
                      options={costCenterOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Select Vertical"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                    <button
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-12 mt-3">
            <DynamicGrid
              title={gridState.title}
              options={objects}
              data={gridState.data}
              columns={gridState.columns}
            />
          </div>
        </div>
      </div>

      <section className="main_content">
        {/* {(grid.id === 0 || grid.id === 1) && (
          <DynamicGrid
            title={"Invoices This Month"}
            options={objects}
            data={dataset}
            columns={gridColums_Invoice}
          />
        )}
        {grid.id === 2 && (
          <DynamicGrid
            title={"Capacity Utilization"}
            options={objects}
            data={dataset_2}
            columns={gridColums_Capacity}
          />
        )}
        {grid.id === 3 && (
          <DynamicGrid
            title={"Non-chargeable Mandays - by reason"}
            options={objects}
            data={actual}
            columns={gridColums_Non_Charageable}
          />
        )} */}
      </section>
    </>
  );
};

export default ManagementDashboardReport;
